import React, { useState, useEffect, useRef } from "react";
import { defineMessages, FormattedRelative, injectIntl } from "react-intl";
import { Label } from "cci-component";
import { localize } from "cci-utility";

const messages = defineMessages({
  updated: { id: "updated", defaultMessage: "Updated " }
});

/**
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 */
const Updater = props => {
  const [count, setCount] = useState(0),
    date = Date.now();

  useInterval(() => {
    props.refetch();
  }, 10 * 60 * 1000 /*ten minutes*/);

  return (
    <FormattedRelative value={date}>
      {formattedStamp => (
        <Label>{localize(props.intl, messages.updated) + formattedStamp}</Label>
      )}
    </FormattedRelative>
  );
};

function useInterval(callback, delay) {
  const savedCallback = useRef();

  // Remember the latest function.
  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  // Set up the interval.
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }
    if (delay !== null) {
      let id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default injectIntl(Updater);
